/** @private */
enum EspSsnType {
	false,	// Purposely at index 0
	DNI,	// 8 digits + 1 letter
	NIE		// 1 letter + 7 digits + 1 letter
}

/** @private */
const letters = "TRWAGMYFPDXBNJZSQVHLCKE";

/** @private */
const letterOfDni = function (dni: number): string {
	// Returns the letter corresponding to a DNI number
	return letters.charAt(dni % 23);
}

/** @private */
const typeOfSsn = function (ssn: string): EspSsnType {
	const dniReg = new RegExp("^([0-9]{8})([" + letters + "]{1})$");
	const nieReg = new RegExp("^([XYZ]{1})([0-9]{7})([" + letters + "]{1})$");

	if (ssn.match(dniReg)) {
		return EspSsnType.DNI;
	}

	if (ssn.match(nieReg)) {
		return EspSsnType.NIE;
	}

	return EspSsnType.false;
}

/** @private */
const lastChar = function (ssn: string): string {
	return ssn[ssn.length - 1];
}

/** @private */
const replaceFirstCharWithThis = function (ssn: string): string {
	// In case the NIE starts with X, it is calculated ignoring the X and using the 7 digits
	// if the NIE starts with Y the letter Y is replaced with the number 1
	// if the NIE starts with Z the letter Z is replaced with the number 2
	// then the same calculation is performed.
	switch (ssn) {
		default:
		case "X":
			return "";
		case "Y":
			return "1";
		case "Z":
			return "2";
	}
}

export function validateSpanishSsn(ssn: string): boolean {

	if (!ssn || ssn.length !== 9) return false;

	const ssnUppercased = ssn.toUpperCase();

	const type = typeOfSsn(ssnUppercased);
	if (!type) return false;

	const onlyNumbers = ssnUppercased.replace(/[^0-9]+/g, "");
	const last = lastChar(ssnUppercased);

	if (type === EspSsnType.DNI) {
		return letterOfDni(Number(onlyNumbers)) === last;
	}

	if (type !== EspSsnType.NIE) {
		return false;
	}

	const replacement = replaceFirstCharWithThis(ssnUppercased[0]);
	const concatNumber = Number(replacement + onlyNumbers);
	return letterOfDni(concatNumber) === last;
}
